import BossModel from "@/models/BossModel";

export default class History extends BossModel {

    static apiUrl = 'proposal/product/history';

    static entity = 'proposalProductHistories';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_product_id: this.number(null),
            modified_by_user_id: this.number(null),
            currency_id: this.number(null),
            purchase_price: this.number(null),
            sale_price: this.number(null),
            breakdown: this.attr(null),
            created_at: this.attr(null),
        }
    }
}
